import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FormService } from '../form.service';

import get from 'lodash-es/get';
import set from 'lodash-es/set';

@Component({
  selector: 'app-form-template-expansion-panels',
  templateUrl: './form-template-expansion-panels.component.html',
  styleUrls: ['./form-template-expansion-panels.component.scss'],
})
export class FormTemplateExpansionPanelsComponent implements OnInit {
  @Input() panels: any[];
  @Output() onformChange: EventEmitter<any> = new EventEmitter();
  expansionPanels: any[];

  constructor(private formService: FormService) {}

  ngOnInit() {
    this.expansionPanels = this.panels.map((panel: any) =>
      set(panel, 'formGroup', this.formService.generateFormGroup(panel.forms)),
    );
  }

  open(panel: any): void {
    panel.expanded = panel.expanded ? panel.expanded : !panel.expanded;
  }

  close(panel: any) {
    panel.expanded = panel.expanded ? !panel.expanded : panel.expanded;
  }

  formChange({ update, formGroup }: any, panel: any): void {
    if (formGroup) {
      this.expansionPanels.map((expansionPanel: any) =>
        this._disableActions(
          get(expansionPanel, 'actions', []),
          formGroup.invalid,
        ),
      );
    }
    if (panel.formsCallback) {
      panel.formsCallback(update);
    }
    this.onformChange.emit(update);
  }

  _disableActions(actions: any[], disableAction: boolean): any[] {
    return actions.map((action: any) => set(action, 'disable', disableAction));
  }

  actionClick(action: any, panel: any) {
    action.callback(panel.formGroup.value);
  }
}
